import React, { Component, Fragment } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Loader } from '@components/common';
import utils from '@utils';

class Attachments extends Component {
	constructor() {
		super();
		this.state = {
			loading : false,
		};
	}

	shouldComponentUpdate = ({ data, loading, downloadAllArray }, { loading : localLoading }) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(lastProps.data, data)
			|| !isEqual(lastProps.loading, loading)
			|| !isEqual(lastProps.downloadAllArray, downloadAllArray)
			|| !isEqual(lastState.loading, localLoading)
		);
	};

	downloadAllClicked = () => {
		const { downloadAllArray } = this.props;
		this.setState({ loading : true });
		utils.downloadAllFunction(downloadAllArray).then(() => {
			this.setState({ loading : false });
		}, () => {
			this.setState({ loading : false });
		});
	}

	render() {
		const { data, loading } = this.props;
		const { loading : localLoading } = this.state;
		return (
			<Fragment>
				<Choose>
					<When condition={data.length}>
						<div className="flex margin-bottom-20">
							<i className="fa fa-paperclip" />
							<span className="flex-1 font-size-12 padding-left-5">Uploaded files</span>
							<span
								className="flex-1 text-right font-size-12 cursor-pointer"
								onClick={() => this.downloadAllClicked()}
								role="button"
								onKeyPress={null}
								tabIndex={0}
							>
								Download All
							</span>
						</div>
						<For
							each="item"
							of={data}
						>
							<div
								key={item.id}
								className="flex margin-bottom-5"
							>
								<span className="flex-1 text-center font-size-12 font-regular-italic bg-gray-1">{ item.date }</span>
								<a
									className="flex-2 font-size-12 padding-left-10"
									target="_blank"
									rel="noopener noreferrer"
									href={item.url}
									download={item.title}
								>
									{ item.title }
								</a>
								<span className="flex-1 font-size-10 font-regular-italic">
									by
									{ item.userName }
								</span>
							</div>
						</For>
					</When>
					<Otherwise>
						<div className="margin-bottom-10 margin-top-10 flex-center">
							<span className="font-size-14 font-light">No Attachments.</span>
						</div>
					</Otherwise>
				</Choose>
				<Loader active={loading || localLoading} />
			</Fragment>
		);
	}
}

Attachments.propTypes = {
	data             : PropTypes.array,
	loading          : PropTypes.bool,
	downloadAllArray : PropTypes.array,
};

Attachments.defaultProps = {
	data             : [],
	loading          : false,
	downloadAllArray : [],
};

export default Attachments;
